import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  margin: 15px 10px;
  padding: 30px 20px;
  height: 100%;
  min-height: 425px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 5px;
`;

export const Divisor = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgb(204, 204, 204);
`;
